import React from 'react';
import clsx from 'clsx';

interface TagProps {
  tagSize?: string;
  tagType?: string;
}

const ProductTag: React.FC<
  TagProps & React.HTMLAttributes<HTMLDivElement> & ProductTagModel
> = ({ tagSize = 'small', tagType = 'regular', id, name, ...props }) => {
  return (
    <div
      {...(props as any)}
      className={clsx(
        props.className,
        'text-sm py-1 px-2 uppercase text-white rounded-sm font-satoshi-bold border-transparent border border-solid',
        tagType == 'regular' && 'bg-black',
        tagType == 'campaign' && 'bg-primary-500'
      )}
    />
  );
};

export default ProductTag;
